import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {useQueryClient, useQuery, useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getListSelfCares, deleteSelfCare} from '../../../modules/services/self-care.service'
import {InputDefault, TableDefault} from '../../../components/ui'
import ModalFormCycle from '../../../components/sections/ModalFormCycle'
import {getBreadCrumbs} from '../breadcrumbs'

const SelfCarePage = () => {
  const headFields = ['Cycle', 'Name', 'Description', 'Weeks']
  const bodyFields = [
    'attributes.cycle',
    'attributes.name',
    {text: 'attributes.description', truncate: 50},
    'attributes.weeks',
  ]

  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  const queryClient = useQueryClient()
  const {data} = useQuery(['getListSelfCares', search, page], async () =>
    getListSelfCares(search, page)
  )
  const cycles = (data?.data as Array<any>)?.map((cycle) => ({
    ...cycle,
    attributes: {...cycle.attributes, weeks: Object.keys(cycle.attributes.activities).length},
  }))
  const pageCount = data?.meta?.pagination.pageCount

  const deleteMutation = useMutation((id) => deleteSelfCare(id), {
    onSuccess: async () => {
      toast.success('Delete Data Success')
      await queryClient.invalidateQueries('getListSelfCares')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const handleDelete = (id: any) => {
    deleteMutation.mutate(id)
  }

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Self Care - Cycle</p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <Link to='/self-care-plan/self-carecreate'>
                <button className='btn btn-primary'>Add Cycle</button>
              </Link>
            </div>
            <div className='d-flex flex-row gap-4'>
              <InputDefault
                placeholder='Search'
                left={<i className='bi bi-search' />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TableDefault
          head={headFields}
          body={bodyFields}
          data={cycles}
          href='self-care-plan/self-care'
          handleDelete={handleDelete}
          allPaginate={pageCount}
          page={page}
          setsPage={setPage}
          nextPage={nextPage}
          prevPage={prevPage}
          showEdit
          texts={'Apakah anda yakin ingin menghapus cycle ini'}
        />
        <ModalFormCycle />
      </div>
    </>
  )
}

const SelfCareWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('self-care-plan/self-care')}>
        {intl.formatMessage({id: 'MENU.SELF_CARE'})}
      </PageTitle>
      <SelfCarePage />
    </>
  )
}

export default SelfCareWrapper
